import React from "react";
import DirectorMatches from "../Matches/DirectorMatches";
export const UnifiedOwnedMatches_Page = { path: "/matches/manage/matches", element: <DirectorMatches /> };
